export default __webpack_public_path__ + "static/media/teamMember6.73599ab3.png";